export default {
  feedback: false,
  wilkommen: false,
  konto: false,
  release: [],
  filter: [],
  notRemember: false
}

